import { IOption } from '@scuf/common/dist/components/Select/ISelectProps';
import { RMAreportTypesMf, RmaOptionMf, RmaStatusCAMf, RmaSupportLevelCAMf, TrueFalseMf, WorkOrderOptionMf } from './rmaModel';
import { RmaOptionCAMf } from './rmaModelCA';
import { rmaItemsEquipmentModelMf } from './detailsRma';
export const blockedRmaStatusMf = [1, 2, 3, 10, 11, 12, 13, 14, 15, 16, 20, 21, 22, 23, 24, 51, 52, 53, 54, 55];
// Já tem no Backend

export const approvalStatusOptions: RmaOptionMf[] = [
    { value: 51, text: 'Aguardando Aprovação de Qualidade', color: 'yellow' },
    { value: 52, text: 'Aguardando Aprovação de Logística', color: 'yellow' },
    { value: 53, text: 'Aguardando Aprovação de CX', color: 'yellow' },
    { value: 54, text: 'Aguardando Informação do Cliente', color: 'yellow' },
    { value: 55, text: 'Transferido para RMA de Serviços', color: 'orange' },
    { value: 10, text: 'Finalizado', color: 'green' },
    { value: 16, text: 'Aberto', color: 'yellow' },
    { value: 3, text: 'Aguardando Recebimento', color: 'yellow' }
];

export const statusOptionsMf: RmaOptionMf[] = [
    { value: 1, text: 'Aguardando Processamento', color: 'yellow' },
    { value: 2, text: 'Aguardando Suporte Técnico', color: 'yellow' },
    { value: 3, text: 'Aguardando Recebimento', color: 'yellow' },
    { value: 4, text: 'Em Analise', color: 'blue' },
    { value: 5, text: 'Aguardando Aprovação', color: 'yellow' },
    { value: 6, text: 'Aprovado', color: 'blue' },
    { value: 7, text: 'Equipamento em Manutenção', color: 'orange' },
    { value: 8, text: 'Nota Fiscal Emitida', color: 'blue' },
    { value: 9, text: 'Equipamento Expedido', color: 'blue' },
    { value: 10, text: 'Finalizado', color: 'green' },
    { value: 11, text: 'Finalizado Recusado', color: 'red' },
    { value: 12, text: 'Expirado', color: 'red' },
    { value: 13, text: 'Recusado', color: 'red' },
    { value: 14, text: 'Reprovado', color: 'red' },
    { value: 15, text: 'Indefinido', color: 'orange' },
    { value: 16, text: 'Aberto', color: 'yellow' },
    { value: 17, text: 'Preparando devolução', color: 'red' },
    { value: 18, text: 'Correção', color: 'orange' },
    { value: 19, text: 'Aguardando Peça', color: 'yellow' },
    { value: 20, text: 'Aguardando retorno ao Cliente', color: 'yellow' },
    { value: 21, text: 'Aguardando ficha cadastral', color: 'yellow' },
    { value: 22, text: 'Aguardando pedido de compra', color: 'yellow' },
    { value: 23, text: 'Pedido de compra divergente', color: 'red' },
    { value: 24, text: 'Bloqueio Financeiro', color: 'red' },
    { value: 51, text: 'Aguardando Aprovação de Qualidade', color: 'yellow' },
    { value: 52, text: 'Aguardando Aprovação de Logística', color: 'yellow' },
    { value: 53, text: 'Aguardando Aprovação de CX', color: 'yellow' },
    { value: 54, text: 'Aguardando Informação do Cliente', color: 'yellow' },
    { value: 55, text: 'Transferido para RMA de Serviços', color: 'orange' }
];

export const tiposRelatorio: IOption[] = [
    { text: 'Resumo', value: 1 },
    { text: 'Resumo Qa', value: 2 },
    { text: 'Histórico', value: 3 }
];

export const semanas: RmaOptionMf[] = [
    { value: 1, text: 'Semana 1' },
    { value: 2, text: 'Semana 2' },
    { value: 3, text: 'Semana 3' },
    { value: 4, text: 'Semana 4' },
    { value: 5, text: 'Semana 5' },
    { value: 6, text: 'Semana 6' },
    { value: 7, text: 'Semana 7' },
    { value: 8, text: 'Semana 8' },
    { value: 9, text: 'Semana 9' },
    { value: 10, text: 'Semana 10' },
    { value: 11, text: 'Semana 11' },
    { value: 12, text: 'Semana 12' },
    { value: 13, text: 'Semana 13' },
    { value: 14, text: 'Semana 14' },
    { value: 15, text: 'Semana 15' },
    { value: 16, text: 'Semana 16' },
    { value: 17, text: 'Semana 17' },
    { value: 18, text: 'Semana 18' },
    { value: 19, text: 'Semana 19' },
    { value: 20, text: 'Semana 20' },
    { value: 21, text: 'Semana 21' },
    { value: 22, text: 'Semana 22' },
    { value: 23, text: 'Semana 23' },
    { value: 24, text: 'Semana 24' },
    { value: 25, text: 'Semana 25' },
    { value: 26, text: 'Semana 26' },
    { value: 27, text: 'Semana 27' },
    { value: 28, text: 'Semana 28' },
    { value: 29, text: 'Semana 29' },
    { value: 30, text: 'Semana 30' },
    { value: 31, text: 'Semana 31' },
    { value: 32, text: 'Semana 32' },
    { value: 33, text: 'Semana 33' },
    { value: 34, text: 'Semana 34' },
    { value: 35, text: 'Semana 35' },
    { value: 36, text: 'Semana 36' },
    { value: 37, text: 'Semana 37' },
    { value: 38, text: 'Semana 38' },
    { value: 39, text: 'Semana 39' },
    { value: 40, text: 'Semana 40' },
    { value: 41, text: 'Semana 41' },
    { value: 42, text: 'Semana 42' },
    { value: 43, text: 'Semana 43' },
    { value: 44, text: 'Semana 44' },
    { value: 45, text: 'Semana 45' },
    { value: 46, text: 'Semana 46' },
    { value: 47, text: 'Semana 47' },
    { value: 48, text: 'Semana 48' },
    { value: 49, text: 'Semana 49' },
    { value: 50, text: 'Semana 50' },
    { value: 51, text: 'Semana 51' },
    { value: 52, text: 'Semana 52' },
    { value: 53, text: 'Semana 53' }
];

export const cauzaRaizLista: IOption[] = [
    { value: 'Customer needed different configuration / reordered', text: 'Customer needed different configuration / reordered' },
    { value: 'Customer refused delivery / Returned, not used', text: 'Customer refused delivery / Returned, not used' },
    { value: 'Ship to Wrong Address - Shipping Address matches PO', text: 'Ship to Wrong Address - Shipping Address matches PO' },
    {
        value: 'Ship to Wrong Address - Shipping Address does not match PO',
        text: 'Ship to Wrong Address - Shipping Address does not match PO'
    },
    { value: 'Shipping Method Error - Shipping method matches PO', text: 'Shipping Method Error - Shipping method matches PO' },
    {
        value: 'Shipping Method Error - Shipping method does not match PO',
        text: 'Shipping Method Error - Shipping method does not match PO'
    },
    { value: 'Delivery Too Early/Late - Carrier No Show', text: 'Delivery Too Early/Late - Carrier No Show' },
    { value: 'Incorrect Freight Charge', text: 'Incorrect Freight Charge' },
    { value: 'Incorrect Price on Invoice', text: 'Incorrect Price on Invoice' },
    { value: 'Quantity discrepancy - Quantity matches PO', text: 'Quantity discrepancy - Quantity matches PO' },
    { value: 'Quantity discrepancy - Quantity does not match PO', text: 'Quantity discrepancy - Quantity does not match PO' },
    { value: 'Duplicate shipment', text: 'Duplicate shipment' },
    { value: 'Wrong item/incorrect product shipped', text: 'Wrong item/incorrect product shipped' },
    { value: 'Kitting - Incorrect product/quantity in kit', text: 'Kitting - Incorrect product/quantity in kit' },
    { value: 'Damage / Packaging (Inadequate packaging)', text: 'Damage / Packaging (Inadequate packaging)' },
    {
        value: 'Documentation/Labelling (Packing slip, customs docs, etc.)',
        text: 'Documentation/Labelling (Packing slip, customs docs, etc.)'
    },
    { value: 'Damaged in transit', text: 'Damaged in transit' },
    {
        value: 'Carrier did not Deliver / Lost Shipment / Cargo Stolen',
        text: 'Carrier did not Deliver / Lost Shipment / Cargo Stolen'
    },
    { value: 'Incorrect Tax on Invoice', text: 'Incorrect Tax on Invoice' },
    { value: 'Incorrect Exchange Rate on Invoice', text: 'Incorrect Exchange Rate on Invoice' }
];

export const listaCategorias: IOption[] = [
    { value: 'No Error, No Escape', text: 'No Error, No Escape' },
    { value: 'Customer Service / Order Entry Error', text: 'Customer Service / Order Entry Error' },
    { value: 'Distribution /Logistic Error', text: 'Distribution /Logistic Error' },
    { value: 'Not PPM Issue', text: 'Not PPM Issue' },
    { value: 'NA', text: 'NA' },
    { value: 'Other Admin Error', text: 'Other Admin Error' }
];

export const shippingTypeMf: IOption[] = [
    { text: 'NÃO SE APLICA', value: 'NÃO SE APLICA' },
    { text: 'CLIENTE NÃO SOLICITOU', value: 'CLIENTE NÃO SOLICITOU' },
    { text: 'SOLICITADA', value: 'SOLICITADA' },
    { text: 'EM PROCESSAMENTO', value: 'EM PROCESSAMENTO' },
    { text: 'ENVIO PELA HONEYWELL', value: 'ENVIO PELA HONEYWELL' },
    { text: 'ENVIO PELO CLIENTE', value: 'ENVIO PELO CLIENTE' },
    { text: 'COLETA TRANSPORTADORA', value: 'COLETA TRANSPORTADORA' },
    { text: 'POSTAGEM CORREIOS', value: 'POSTAGEM CORREIOS' }
];

export const reportTypesMf: RMAreportTypesMf[] = [
    { text: 'RMA', value: 0, restrict: false },
    { text: 'Ordens de Serviço', value: 1, restrict: false },
    // { text: 'Chat', value: 2, restrict: true },
    { text: 'Pesquisa de Satisfação', value: 3, restrict: true }
    // { text: 'Parceiros', value: 4, restrict: true }
];

// Já tem no Backend
export const typeOptionsMf: RmaOptionMf[] = [
    { value: 1, text: 'Garantia de Serviços', color: 'blue' },
    { value: 2, text: 'Garantia de Fábrica', color: 'yellow' },
    { value: 3, text: 'Troca em Garantia', color: 'green' },
    { value: 4, text: 'Contrato de Manutenção', color: 'orange' },
    { value: 5, text: 'Avulso', color: 'blue' },
    { value: 6, text: 'Outros', color: 'red' }
];

export const modelXptoMf: RmaOptionMf[] = [
    { value: 1, text: 'Model teste 1', color: 'blue' },
    { value: 2, text: 'Model teste 2', color: 'yellow' }
];
// Já tem no Backend

export const localXptoMf: RmaOptionMf[] = [
    { value: 1, text: 'Garantia de Serviços', color: 'blue' },
    { value: 2, text: 'Garantia de Fábrica', color: 'yellow' },
    { value: 3, text: 'Troca em Garantia', color: 'green' },
    { value: 4, text: 'Contrato de Manutenção', color: 'orange' },
    { value: 5, text: 'Avulso', color: 'blue' },
    { value: 6, text: 'Outros', color: 'red' }
];
// Já tem no Backend

export const problemaXptoMf: RmaOptionMf[] = [
    { value: 1, text: 'Garantia de Serviços', color: 'blue' },
    { value: 2, text: 'Garantia de Fábrica', color: 'yellow' },
    { value: 3, text: 'Troca em Garantia', color: 'green' },
    { value: 4, text: 'Contrato de Manutenção', color: 'orange' },
    { value: 5, text: 'Avulso', color: 'blue' },
    { value: 6, text: 'Outros', color: 'red' }
];

export const serviceTypeOptionsMf: RmaOptionCAMf[] = [
    { value: 1, text: 'Repair & Return' },
    { value: 2, text: 'Advanced Exchange' }
];

export const supportMf: RmaOptionCAMf[] = [
    { value: 1, text: 'Warrantly' },
    { value: 2, text: 'Billable' },
    { value: 3, text: 'Standard Repair' },
    { value: 4, text: 'AE Common Pool' },
    { value: 5, text: 'AE Premier Pool' }
];

export const typeRequestMf: IOption[] = [
    { value: 1, text: 'Solicitação de arquivo' },
    { value: 2, text: 'Solicitação de Alt. de Enderço' },
    { value: 3, text: 'Solicitação de Alt. de Remessa' },
    { value: 4, text: 'Solicitação de Alt. de Equipamentos' }
];

export const attendanceTimeMf: IOption[] = [
    { value: '1', text: '08:00-12:00 & 13:00-17:30' },
    { value: '2', text: '08:00-12:00 & 13:00-18:00' },
    { value: '3', text: '08:00-12:00 & 13:00-18:30' },
    { value: '4', text: '08:00-17:30' }
];

export const materialTypeMf: IOption[] = [
    { value: '1', text: 'Eletrônico' },
    { value: '2', text: 'Outros' }
];
export const typeFileMf: IOption[] = [
    { value: 'NOTA_FISCAL_COMPRA', text: 'Nota Fiscal de Compra' },
    { value: 'PEDIDO_COMPRA', text: 'Pedido de Compra' },
    { value: 'AUTORIZACAO_POSTAGEM', text: 'Autorização de Postagem' },
    { value: 'PRE_NOTA', text: 'Pré Nota' },
    { value: 'OTHER', text: 'Outros' }
];

export const typeSituationMf: IOption[] = [
    //{ value: 1, text: 'Indefinido' },
    { value: 'APROVADO', text: 'Aprovado' },
    { value: 'REPROVADO', text: 'Reprovado' },
    { value: 'RMA DE SERVICO', text: 'Rma de Serviços' }
];

export const typeShippingMf: IOption[] = [
    //{ value: 1, text: 'Indefinido' },
    { value: 'NÃO SE APLICA', text: 'Não se Aplica' },
    { value: 'EM PROCESSAMENTO', text: 'Em processamento' },
    { value: 'CLIENTE NÃO SOLICITOU', text: 'Cliente não solicitou' },
    { value: 'SOLICITADA', text: 'Solicitada' },
    { value: 'ENVIO PELA HONEYWELL', text: 'Envio pela Honeywell' },
    { value: 'ENVIO PELO CLIENTE', text: 'Envio pelo cliente' },
    { value: 'COLETA TRANSPORTADORA', text: 'Coleta transportadora' },
    { value: 'POSTAGEM CORREIOS', text: 'Postagem correios' }
];

export const modelOptionsMf: IOption[] = [
    { value: 1, text: 'N1' },
    { value: 2, text: 'N2' },
    { value: 3, text: 'N3' }
];

export const problemsMf: IOption[] = [
    { value: 1, text: 'Adesivo' },
    { value: 2, text: 'Alça de Mão' },
    { value: 3, text: 'Alto Falante/Microfone' },
    { value: 4, text: 'Antena' },
    { value: 5, text: 'Barra de Corte' },
    { value: 6, text: 'Bateria' },
    { value: 7, text: 'Berço de Comunicação' },
    { value: 8, text: 'Bluetooth' },
    { value: 9, text: 'Borracha Lateral' },
    { value: 10, text: 'Botão' },
    { value: 11, text: 'Botão Lateral' },
    { value: 12, text: 'Botão Liga-Desliga' },
    { value: 13, text: 'Cabeçote' },
    { value: 14, text: 'Cabo Externo' },
    { value: 15, text: 'Cabo Interno' },
    { value: 16, text: 'Câmera' },
    { value: 17, text: 'Carcaça' },
    { value: 18, text: 'Conector' },
    { value: 19, text: 'Contato' },
    { value: 20, text: 'Cutter' },
    { value: 21, text: 'Display' },
    { value: 22, text: 'Fonte de Alimentação' },
    { value: 23, text: 'Gatilho' },
    { value: 24, text: 'GPS' },
    { value: 25, text: 'GSM/GPRS' },
    { value: 26, text: 'Guia' },
    { value: 27, text: 'Janela de Leitura' },
    { value: 28, text: 'Mecanismo' },
    { value: 29, text: 'Memória' },
    { value: 30, text: 'Placa Principal' },
    { value: 31, text: 'RFID' },
    { value: 32, text: 'Rolete' },
    { value: 33, text: 'Scanner' },
    { value: 34, text: 'Sensor' },
    { value: 35, text: 'Software' },
    { value: 36, text: 'Suporte' },
    { value: 37, text: 'Tampa do Chip' },
    { value: 38, text: 'Teclado' },
    { value: 39, text: 'Touch Panel' },
    { value: 40, text: 'Touch Screen' },
    { value: 41, text: 'Wi-Fi' },
    { value: 42, text: 'Outro' }
];

export const workOrderStatusMf: WorkOrderOptionMf[] = [
    { text: 'Em Análise', value: [1, 2, 3, 4, 5, 6], color: 'yellow' },
    { text: 'Aguardando Aprovação', value: [7], color: 'yellow' },
    { text: 'Aprovado', value: [10], color: 'green' },
    { text: 'Equipamento em Manutenção', value: [11, 12, 13, 14], color: 'yellow' },
    { text: 'Nota Fiscal Emitida', value: [16], color: 'green' },
    { text: 'Equipamento Expedido', value: [17], color: 'green' },
    { text: 'Aguardando Peças', value: [9], color: 'yellow' },
    { text: 'Reprovado', value: [8], color: 'red' },
    { text: 'Preparando para devolução', value: [15], color: 'yellow' },
    { text: 'Em processamento', value: [18], color: 'yellow' },
    { text: 'Bloqueio Financeiro', value: [19], color: 'red' }
];

export const workOrderDefaultStatusMf: WorkOrderOptionMf = { text: 'Em Análise', value: [], color: 'yellow' };
export const maintenanceStatusMf: IOption[] = [
    { value: 1, text: 'Aguardando Aprovação' },
    { value: 2, text: 'Aprovado Parcialmente' },
    { value: 3, text: 'Reprovado' },
    { value: 4, text: 'Aprovado' }
];
export const statusRmaCAMf: RmaStatusCAMf[] = [
    { text: 'Awaiting Processing', value: 0, color: 'yellow', toRma: true, description: 'Arguardando Avaliação' },
    { text: 'Completed', value: 1, color: 'green', toRma: true, description: 'Completed' },
    { text: 'Open', value: 2, color: 'blue', toRma: true, description: 'Open' }
];
export const supportLevelCAMf: RmaSupportLevelCAMf[] = [
    { value: 0, text: 'Repair & Return', support: ['Warranty', 'Billable', 'Standard Repair'], color: 'green' },
    { value: 1, text: 'Advanced Exchange', support: ['AE Common Pool', 'AE Premier Pool'], color: 'green' }
];
export const YesNoMf: TrueFalseMf[] = [
    { value: true, text: 'Yes' },
    { value: false, text: 'No' }
];
export const modelShippingConditionMf: IOption[] = [
    { value: 1, text: 'Standard' },
    { value: 2, text: 'Overnight' }
];

export const volOptionMf: IOption[] = [
    { value: 1, text: 'NF (Integral)' },
    { value: 2, text: 'Caixas' },
    { value: 3, text: 'Paletes' },
    { value: 4, text: 'Unidades' }
];

export const timeMf: IOption[] = [
    { value: 1, text: 'Antes do uso' },
    { value: 2, text: 'Dentro de 30 dias' },
    { value: 3, text: 'Depois de 30 dias' }
];

export const typeOptionProductsMf: RmaOptionMf[] = [
    { value: 1, text: 'Coletores de dados' },
    { value: 2, text: 'Impressoras Fixas' },
    { value: 3, text: 'Leitores de código de barras' },
    { value: 4, text: 'RFID' },
    { value: 5, text: 'Acessórios para coletores, scaners e Impressoras' },
    { value: 6, text: 'Detecção de Gás e Chamas' },
    { value: 7, text: 'Vocollect' },
    { value: 8, text: 'Impressoras Portáteis' }
];
